import React, { Fragment, useContext } from 'react'
import Toggle from 'react-toggle'
import 'react-toggle/style.css'

import { ActionablesContext } from '../../../../contexts/ActionablesContext'
import { CashflowEventsContext } from '../../context'
import { R } from '@utils/currency'

import { ReactComponent as ExpenseIcon } from '@assets/images/cashflow_tag_icon.svg'
import { ReactComponent as IncomeIcon } from '@assets/images/cashflow_growth_icon.svg'
import { Badge } from '@components/Badge'

export const EmptyEventsList = () =>
  <Fragment>
    <div className='cashflow-event-card cashflow-event-card--placeholder' />
    <div className='cashflow-event-card cashflow-event-card--placeholder' />
  </Fragment>

export const EventsList = () => {
  const { state } = useContext(CashflowEventsContext)
  const { cashflowEvents } = state
  return (
    <Fragment>
      {cashflowEvents.map((event, idx) =>
        event.joint
          ? <JointEventCard key={idx} event={event} idx={idx} />
          : <EventCard key={idx} event={event} idx={idx} />
      )}
    </Fragment>
  )
}

const EventCard = ({ event, idx }) => {
  const eventWithIndex = { ...event, index: idx }
  const context = useContext(CashflowEventsContext)
  const { state, actions } = context
  const { cashflowEventsReadOnly } = useContext(ActionablesContext)
  const [{ loading }, { editEvent, toggleEvent }] = [state, actions]

  const eventAge = event.start_age
  const eventYear = event.event_year

  return (
    <div key={idx} className='ui-card ui-card--cashflow-event-card cashflow-event-card cashflow-event-card__content'>
      <div className='cashflow-event'>
        <div className='cashflow-event__details'>
          <div className={`event-details-icon event-details-icon--${eventWithIndex.event_type}`}>
            <EventIcon type={eventWithIndex.event_type} />
          </div>
          <div className='event-details-information'>
            {event.partial && <Badge variant='success'>Joint event</Badge>}
            <h2>{eventWithIndex.name}</h2>
            <p> {eventAge} ({eventYear}) <span className='hidden xs:inline-block'>|</span> <br className='xs:hidden' /> {R(eventWithIndex.amount).format()}</p>
          </div>
        </div>

        <div className='cashflow-event__actions gap-2'>
          <div className='cashflow-actions__toggle'>
            <Toggle
              checked={eventWithIndex.status === 'active'}
              className='app-toggle'
              icons={false}
              disabled={loading || event.partial || cashflowEventsReadOnly}
              onChange={() => toggleEvent(eventWithIndex, context)}
            />
          </div>
          {!cashflowEventsReadOnly && !event.partial &&
            <a className='cashflow-actions__edit' onClick={editEvent(eventWithIndex)}>edit</a>
          }
        </div>

      </div>
    </div>

  )
}

const JointEventCard = ({ event, idx }) => {
  const eventWithIndex = { ...event, index: idx }
  const context = useContext(CashflowEventsContext)
  const { state, actions } = context
  const { cashflowEventsReadOnly } = useContext(ActionablesContext)
  const [{ loading }, { editEvent, toggleEvent }] = [state, actions]

  const eventYear = event.start_year

  return (
    <div key={idx} className='ui-card ui-card--cashflow-event-card cashflow-event-card cashflow-event-card__content'>
      <div className='cashflow-event'>
        <div className='cashflow-event__details'>
          <div className={`event-details-icon event-details-icon--${eventWithIndex.event_type}`}>
            <EventIcon type={eventWithIndex.event_type} />
          </div>
          <div className='event-details-information'>
            <h2>{eventWithIndex.name}</h2>
            <p> {eventYear} <span className='hidden xs:inline-block'>|</span> <br className='xs:hidden' /> {R(eventWithIndex.amount).format()}</p>
          </div>
        </div>

        {!cashflowEventsReadOnly &&
          <div className='cashflow-event__actions'>
            <div className='cashflow-actions__toggle'>
              <Toggle
                checked={eventWithIndex.status === 'active'}
                className='app-toggle'
                icons={false}
                disabled={loading}
                onChange={() => toggleEvent(eventWithIndex, context)}
              />
            </div>
            <a className='cashflow-actions__edit' onClick={editEvent(eventWithIndex)}>edit</a>
          </div>
        }
      </div>
    </div>

  )
}

const EventIcon = ({ type }) => {
  const icon = type === 'income' ? <IncomeIcon /> : <ExpenseIcon />

  return (
    <div>{icon}</div>
  )
}

const currentYear = () =>
  new Date().getFullYear()
